<template>
  <div class="card flex-grow-1 shadow-sm">
    <div class="card-header">Unsubscribed Count</div>
    <div class="card-body">
      <h2 class="text-center">{{ count }}</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnsubscribedCountComponent',
  data () {
    return {
      count: 0
    }
  },
  created () {
    this.doRequest()
  },
  methods: {
    doRequest () {
      this.axios.get('dashboard/unsubscribed-count')
        .then(({data}) => {
          if (data.data) {
            this.count = data.data
          }
        }).catch(() => {
          this.$toastr.error('Internal server error')
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/UnsubscribedCountComponent.vue